import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

// Selectors
import { selectLatestAvmPercentageChangeInValuationHistory } from 'src/store/selectors/valuationHistory'

// Utils
import history from 'src/history'
import { dispatchEvent } from 'src/helpers/tagManager'
import {
  AVMDifferenceLearnMoreClicked,
  AVMDifferenceToolTipLoad,
} from 'src/constants/trackingEvents'
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Components
import { Text, Button, Format } from 'src/Components'

// Styles
import styles from '../Chart.module.scss'

const AvmDifferenceToolTipWarning = () => {
  const avmPercentageChange = useSelector(
    selectLatestAvmPercentageChangeInValuationHistory
  )

  const handleLearnMore = () => {
    history.push(OVERLAY_HELPERS.avmDiffWarning.buildPath())
  }

  useEffect(() => {
    dispatchEvent(AVMDifferenceToolTipLoad)
  }, [])

  return (
    <>
      <Text
        weight='semibold'
        upperspaced
        className={styles.title}
        variant='neutralCool'
        variantCount='900'
      >
        <FormattedMessage
          id='AVM.chart.tooltip.avmDiff.title'
          defaultMessage='FYI: Your value changed by {percent}'
          values={{
            percent: (
              <Format.Percentage
                value={Math.round(avmPercentageChange * 100)}
              />
            ),
          }}
        />
      </Text>
      <Text
        size='xs'
        variant='neutralCool'
        variantCount='700'
        className={styles.describe}
      >
        <FormattedMessage
          id='AVM.chart.tooltip.avmDiff.describe'
          defaultMessage='Sometimes a big value change can indicate a data issue'
        />
      </Text>
      <Button
        data-qa='avm-warning-learn-more-btn'
        onClick={handleLearnMore}
        track={AVMDifferenceLearnMoreClicked}
        fullWidth
        className={styles.button}
      >
        <FormattedMessage
          id='AVM.chart.tooltip.avmDiff.tooltip.button'
          defaultMessage='Learn more about this'
        />
      </Button>
    </>
  )
}

export default AvmDifferenceToolTipWarning
